/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramConnectionsUserControllerUpsertMutationRequest,
  TelegramConnectionsUserControllerUpsertMutationResponse,
  TelegramConnectionsUserControllerUpsert401,
} from '../../types/TelegramConnectionsUserControllerUpsert.ts';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import { telegramConnectionsUserUpsert } from '../../methods/telegramConnectionsUserUpsert.ts';
import { useMutation } from '@tanstack/react-query';

export const telegramConnectionsUserUpsertMutationKey = () => [{ url: '/api/user/telegram/connections' }] as const;

export type TelegramConnectionsUserUpsertMutationKey = ReturnType<typeof telegramConnectionsUserUpsertMutationKey>;

/**
 * {@link /api/user/telegram/connections}
 */
export function useTelegramConnectionsUserUpsert<TContext>(
  options: {
    mutation?: UseMutationOptions<
      TelegramConnectionsUserControllerUpsertMutationResponse,
      ResponseErrorConfig<TelegramConnectionsUserControllerUpsert401>,
      { data: TelegramConnectionsUserControllerUpsertMutationRequest },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<TelegramConnectionsUserControllerUpsertMutationRequest>> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? telegramConnectionsUserUpsertMutationKey();

  return useMutation<
    TelegramConnectionsUserControllerUpsertMutationResponse,
    ResponseErrorConfig<TelegramConnectionsUserControllerUpsert401>,
    { data: TelegramConnectionsUserControllerUpsertMutationRequest },
    TContext
  >(
    {
      mutationFn: async ({ data }) => {
        return telegramConnectionsUserUpsert(data, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
